import { render, staticRenderFns } from "./AIChatbotIframe.vue?vue&type=template&id=7b6d7de0&scoped=true"
import script from "./AIChatbotIframe.vue?vue&type=script&lang=js"
export * from "./AIChatbotIframe.vue?vue&type=script&lang=js"
import style0 from "./AIChatbotIframe.vue?vue&type=style&index=0&id=7b6d7de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6d7de0",
  null
  
)

export default component.exports